<div class="order-container">
  @if (order) {
    <page-header
      [icon]="'far-shopping-cart'"
      [isOrderLayout]="
        (orderDetailService.canCreateOrEdit && orderDetailService.activeLink === '') ||
        (order && order.isEditable && !orderDetailService.canCreateOrEdit && !orderDetailService.isCancelled)
      "
      [isHeadingNoWrap]="true"
    >
      <ng-container class="custom-title">
        @if (order.id === 0) {
          @if (orderDetailService.activeLink !== '') {
            <span>{{ 'order.stock.new' | translate }}</span>
          }
          @if (orderDetailService.activeLink === '') {
            <span>{{ order?.customer?.name || '' }}</span>
          }
        }
        @if (order.reservationNumber > 0 || order.billNumber > 0) {
          <span data-cy="reservation-number">
            {{ order.reservationNumber > 0 ? ('order' | translate) + ' ' + order.reservationNumber : '' }}
            {{ order.reservationNumber > 0 && order.billNumber > 0 ? ' - ' : '' }}
            {{ order.billNumber > 0 && !order?.relatedParent?.id ? ('bill' | translate) + ' ' + order.billNumber : '' }}
          </span>
        }
        @if (order.billNumber && order.relatedParent?.id) {
          {{
            ('corrective.tax.document' | translate) +
              ' ' +
              order.billNumber +
              (order.relatedParent?.billNumber ? ' ' + ('forBillNo' | translate) + order.relatedParent?.billNumber : '')
          }}
        }
      </ng-container>
      <ng-container class="header-button">
        <div class="row">
          <div class="col-12">
            @if (orderDetailService.canCreateOrEdit && orderDetailService.activeLink === '') {
              <btn
                [label]="'save'"
                [title]="'save' | translate"
                [classes]="['float-right', 'btn-first']"
                [icon]="'far-check'"
                [isLoading]="orderDetailService.loading"
                [spinnerClassesString]="'spinner-white'"
                (onEvent)="orderDetailService.isCreating ? createOrder() : updateOrder()"
                [dataCyAttribute]="'save'"
              ></btn>
            }
            @if (
              order.status &&
              order.status.id === 'reservation' &&
              !orderDetailService.isCreating &&
              !orderDetailService.isCancelled
            ) {
              <btn
                [label]="'order.confirm.and.send'"
                [title]="'order.confirm.and.send' | translate"
                [classes]="['btn-first', 'float-right', 'me-2']"
                [icon]="'far-cart-arrow-down'"
                [isLoading]="orderDetailService.loading"
                (onEvent)="confirmOrder()"
                [dataCyAttribute]="'confirm-and-send'"
              ></btn>
            }
            @if (
              order.status &&
              order.status.id === 'reservation' &&
              !orderDetailService.isCreating &&
              !orderDetailService.isCancelled
            ) {
              <btn
                [label]="'reservation.delete'"
                [title]="'reservation.delete' | translate"
                [classes]="['btn-first-red', 'me-2', 'float-right']"
                [isLoading]="orderDetailService.loading"
                [icon]="'far-trash-alt'"
                (onEvent)="deleteReservation()"
                [dataCyAttribute]="'delete-order'"
              ></btn>
              <btn
                [label]="'reservation.cancel'"
                [title]="'reservation.cancel' | translate"
                [classes]="['btn-first-orange', 'me-2', 'float-right']"
                [isLoading]="orderDetailService.loading"
                [icon]="'far-ban'"
                (onEvent)="cancelReservation()"
                [dataCyAttribute]="'cancel-reservation'"
              ></btn>
            }
            @if (order && order.isEditable && !orderDetailService.canCreateOrEdit && !orderDetailService.isCancelled) {
              <btn
                [label]="'edit'"
                [title]="'edit' | translate"
                [classes]="['btn-first-orange', 'me-2', 'float-right']"
                [icon]="'far-edit'"
                (onEvent)="orderDetailService.canCreateOrEdit = !orderDetailService.canCreateOrEdit"
                [dataCyAttribute]="'edit-order'"
              ></btn>
            }
            @if (
              !orderDetailService.isCreating &&
              !orderDetailService.canCreateOrEdit &&
              orderDetailService.canCreateOrEditNotes
            ) {
              <btn
                [label]="'save'"
                [title]="'save' | translate"
                [classes]="['float-right', 'btn-first']"
                [icon]="'far-check'"
                [isLoading]="orderDetailService.loading"
                (onEvent)="updateOrder()"
                [dataCyAttribute]="'save'"
              ></btn>
            }
            @if (order.status?.id && !orderDetailService.isCreating) {
              <button
                class="btn-third me-2 float-right dropdown-toggle"
                id="dropdownMenu2"
                data-bs-toggle="dropdown"
                data-cy="download-receipt-dropdown"
              >
                {{ 'order.print-and-download' | translate }}
              </button>
            }
            <div class="dropdown-menu margin-right-150" aria-labelledby="dropdownMenu2">
              @if (order.status?.id === 'bill') {
                <button class="dropdown-item" type="button" (click)="downloadInvoiceUrl()">
                  {{ 'invoice' | translate }} A4
                </button>
              }
              @if (order.status?.id === 'bill') {
                <button class="dropdown-item" type="button" (click)="downloadInvoiceIsdocUrl()">
                  {{ 'invoiceIsdoc' | translate }}
                </button>
              }
              @if (movePacksOut()?.length === 1) {
                <button class="dropdown-item" type="button" (click)="downloadPdf(movePacksOut()[0])">
                  {{ 'download.pdf-deliveryNote' | translate }}
                </button>
              }
              @if (movePacksOut()?.length > 1) {
                @for (movePack of movePacksOut(); track movePack) {
                  <button class="dropdown-item" type="button" (click)="downloadPdf(movePack)">
                    {{
                      ('download.pdf-deliveryNote.number' | translate) + '&nbsp;' + 'č.' + '&nbsp;' + movePack.number
                    }}
                  </button>
                }
              }
              @if (movePacksReservation()?.length === 1) {
                <button
                  class="dropdown-item"
                  type="button"
                  (click)="downloadPdf(movePacksReservation()[0])"
                  data-cy="download-receipt"
                >
                  {{ 'download.pdf-pickingList' | translate }}
                </button>
              }
              @if (movePacksReservation()?.length > 1) {
                @for (movePack of movePacksReservation(); track movePack) {
                  <button class="dropdown-item" type="button" (click)="downloadPdf(movePack)">
                    {{ ('download.pdf-pickingList.number' | translate) + '&nbsp;' + movePack.number }}
                  </button>
                }
              }
              @if (order.status?.id === 'reservation' || !order.relatedParent?.id) {
                <button
                  class="dropdown-item"
                  type="button"
                  (click)="downloadReservationUrl()"
                  data-cy="download-receipt"
                >
                  {{ 'order-bill' | translate }} A4
                </button>
              }
            </div>
            @if (orderDetailService.isCreating && orderDetailService.activeLink !== '') {
              <btn
                [btnDisabled]="
                  orderDetailService.activeLink === 'payment-info' &&
                  (!this.order.checkout?.id || !this.order.carrier?.id || !this.order.currency?.id)
                "
                [icon]="'far-arrow-right'"
                [label]="orderDetailService.activeLink === 'customer' ? 'order.continueWithoutCustomer' : 'continue'"
                [title]="
                  orderDetailService.activeLink === 'customer'
                    ? ('order.continueWithoutCustomer' | translate)
                    : ('continue' | translate)
                "
                [classes]="['btn-first', 'float-right']"
                (onEvent)="triggerNextStep()"
                [dataCyAttribute]="'continue'"
              ></btn>
            }
            @if (order?.id > 0) {
              <modal-loggable-history [objectClass]="'Order'" [objectId]="order.id"></modal-loggable-history>
            }
          </div>
        </div>
      </ng-container>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'me-2']"
          [dataCyAttribute]="'order-back-button'"
          [icon]="'far-arrow-left'"
          (onEvent)="triggerBackBtn()"
        ></btn>
      </ng-container>
    </page-header>
  }
  <section class="content order-content">
    <router-outlet></router-outlet>
  </section>
</div>

<!--<div class="order-container">-->
<!--  <page-header-->
<!--    [icon]="'far-shopping-cart'"-->
<!--    *ngIf="order"-->
<!--    [isOrderLayout]="-->
<!--      (orderDetailService.canCreateOrEdit && orderDetailService.activeLink === '') ||-->
<!--      (order && order.isEditable && !orderDetailService.canCreateOrEdit)-->
<!--    "-->
<!--    [isHeadingNoWrap]="true"-->
<!--  >-->
<!--    <ng-container class="custom-title">-->
<!--      <ng-template [ngIf]="order.id === 0">-->
<!--        <span *ngIf="orderDetailService.activeLink !== ''">{{ 'order.stock.new' | translate }}</span>-->
<!--        <span *ngIf="orderDetailService.activeLink === ''">{{ order?.customer?.name || '' }}</span>-->
<!--      </ng-template>-->
<!--      <ng-template [ngIf]="order.reservationNumber > 0 || order.billNumber > 0">-->
<!--        <span data-cy="reservation-number">-->
<!--          {{ order.reservationNumber > 0 ? ('order' | translate) + ' ' + order.reservationNumber : '' }}-->
<!--          {{ order.reservationNumber > 0 && order.billNumber > 0 ? ' - ' : '' }}-->
<!--          {{ order.billNumber > 0 && !order?.relatedParent?.id ? ('bill' | translate) + ' ' + order.billNumber : '' }}-->
<!--        </span></ng-template-->
<!--      >-->
<!--      <ng-template [ngIf]="order.billNumber && order.relatedParent?.id">-->
<!--        {{-->
<!--          ('corrective.tax.document' | translate) +-->
<!--            ' ' +-->
<!--            order.billNumber +-->
<!--            (order.relatedParent?.billNumber ? ' ' + ('forBillNo' | translate) + order.relatedParent?.billNumber : '')-->
<!--        }}-->
<!--      </ng-template>-->
<!--    </ng-container>-->
<!--    <ng-container class="header-button">-->
<!--      <div class="row">-->
<!--        <div class="col-12">-->
<!--          <btn-->
<!--            *ngIf="orderDetailService.canCreateOrEdit && orderDetailService.activeLink === ''"-->
<!--            [label]="'save'"-->
<!--            [title]="'save' | translate"-->
<!--            [classes]="['float-right', 'btn-first']"-->
<!--            [icon]="'far-check'"-->
<!--            [isLoading]="orderDetailService.loading"-->
<!--            [spinnerClassesString]="'spinner-white'"-->
<!--            (onEvent)="orderDetailService.isCreating ? mutationCreateOrder.mutate() : updateOrder()"-->
<!--            [dataCyAttribute]="'save'"-->
<!--          ></btn>-->
<!--          <btn-->
<!--            *ngIf="order.status && order.status.id === 'reservation' && !orderDetailService.isCreating"-->
<!--            [label]="'order.confirm.and.send'"-->
<!--            [title]="'order.confirm.and.send' | translate"-->
<!--            [classes]="['btn-first', 'float-right', 'me-2']"-->
<!--            [icon]="'far-cart-arrow-down'"-->
<!--            [isLoading]="orderDetailService.loading"-->
<!--            (onEvent)="confirmOrder()"-->
<!--            [dataCyAttribute]="'confirm-and-send'"-->
<!--          ></btn>-->
<!--          <btn-->
<!--            *ngIf="order.status && order.status.id === 'reservation' && !orderDetailService.isCreating"-->
<!--            [label]="'reservation.delete'"-->
<!--            [title]="'reservation.delete' | translate"-->
<!--            [classes]="['btn-first-red', 'me-2', 'float-right']"-->
<!--            [isLoading]="orderDetailService.loading"-->
<!--            [icon]="'far-trash-alt'"-->
<!--            (onEvent)="deleteReservation()"-->
<!--            [dataCyAttribute]="'delete-order'"-->
<!--          ></btn>-->
<!--          <btn-->
<!--            *ngIf="order && order.isEditable && !orderDetailService.canCreateOrEdit"-->
<!--            [label]="'edit'"-->
<!--            [title]="'edit' | translate"-->
<!--            [classes]="['btn-first-orange', 'me-2', 'float-right']"-->
<!--            [icon]="'far-edit'"-->
<!--            (onEvent)="orderDetailService.canCreateOrEdit = !orderDetailService.canCreateOrEdit"-->
<!--          ></btn>-->
<!--          <btn-->
<!--            *ngIf="-->
<!--              !orderDetailService.isCreating &&-->
<!--              !orderDetailService.canCreateOrEdit &&-->
<!--              orderDetailService.canCreateOrEdit-->
<!--            "-->
<!--            [label]="'save'"-->
<!--            [title]="'save' | translate"-->
<!--            [classes]="['float-right', 'btn-first']"-->
<!--            [icon]="'far-check'"-->
<!--            [isLoading]="orderDetailService.loading"-->
<!--            (onEvent)="updateOrder()"-->
<!--            [dataCyAttribute]="'save'"-->
<!--          ></btn>-->
<!--          <button-->
<!--            *ngIf="order.status?.id && !orderDetailService.isCreating"-->
<!--            class="btn-third me-2 float-right dropdown-toggle"-->
<!--            id="dropdownMenu2"-->
<!--            data-bs-toggle="dropdown"-->
<!--            data-cy="download-receipt-dropdown"-->
<!--          >-->
<!--            {{ 'order.print-and-download' | translate }}-->
<!--          </button>-->
<!--          <div class="dropdown-menu margin-right-150" aria-labelledby="dropdownMenu2">-->
<!--            <button-->
<!--              *ngIf="order.status?.id === 'bill'"-->
<!--              class="dropdown-item"-->
<!--              type="button"-->
<!--              (click)="downloadInvoiceUrl()"-->
<!--            >-->
<!--              {{ 'invoice' | translate }} A4-->
<!--            </button>-->
<!--            <button-->
<!--              *ngIf="order.status?.id === 'bill'"-->
<!--              class="dropdown-item"-->
<!--              type="button"-->
<!--              (click)="downloadInvoiceIsdocUrl()"-->
<!--            >-->
<!--              {{ 'invoiceIsdoc' | translate }}-->
<!--            </button>-->
<!--            <button-->
<!--              *ngIf="movePacksOut()?.length === 1"-->
<!--              class="dropdown-item"-->
<!--              type="button"-->
<!--              (click)="downloadPdf(movePacksOut()[0])"-->
<!--            >-->
<!--              {{ 'download.pdf-deliveryNote' | translate }}-->
<!--            </button>-->
<!--            <ng-container *ngIf="movePacksOut()?.length > 1">-->
<!--              <button-->
<!--                *ngFor="let movePack of movePacksOut()"-->
<!--                class="dropdown-item"-->
<!--                type="button"-->
<!--                (click)="downloadPdf(movePack)"-->
<!--              >-->
<!--                {{ ('download.pdf-deliveryNote.number' | translate) + '&nbsp;' + 'č.' + '&nbsp;' + movePack.number }}-->
<!--              </button>-->
<!--            </ng-container>-->

<!--            <button-->
<!--              *ngIf="movePacksReservation()?.length === 1"-->
<!--              class="dropdown-item"-->
<!--              type="button"-->
<!--              (click)="downloadPdf(movePacksReservation()[0])"-->
<!--              data-cy="download-receipt"-->
<!--            >-->
<!--              {{ 'download.pdf-pickingList' | translate }}-->
<!--            </button>-->
<!--            <ng-container *ngIf="movePacksReservation()?.length > 1">-->
<!--              <button-->
<!--                *ngFor="let movePack of movePacksReservation()"-->
<!--                class="dropdown-item"-->
<!--                type="button"-->
<!--                (click)="downloadPdf(movePack)"-->
<!--              >-->
<!--                {{ ('download.pdf-pickingList.number' | translate) + '&nbsp;' + movePack.number }}-->
<!--              </button>-->
<!--            </ng-container>-->

<!--            <button-->
<!--              *ngIf="order.status?.id === 'reservation' || !order.relatedParent?.id"-->
<!--              class="dropdown-item"-->
<!--              type="button"-->
<!--              (click)="downloadReservationUrl()"-->
<!--              data-cy="download-receipt"-->
<!--            >-->
<!--              {{ 'order-bill' | translate }} A4-->
<!--            </button>-->
<!--          </div>-->
<!--          <btn-->
<!--            *ngIf="orderDetailService.isCreating && orderDetailService.activeLink !== ''"-->
<!--            [btnDisabled]="-->
<!--              orderDetailService.activeLink === 'payment-info' &&-->
<!--              (!this.order.checkout?.id || !this.order.carrier?.id || !this.order.currency?.id)-->
<!--            "-->
<!--            [icon]="'far-arrow-right'"-->
<!--            [label]="orderDetailService.activeLink === 'customer' ? 'order.continueWithoutCustomer' : 'continue'"-->
<!--            [title]="-->
<!--              orderDetailService.activeLink === 'customer'-->
<!--                ? ('order.continueWithoutCustomer' | translate)-->
<!--                : ('continue' | translate)-->
<!--            "-->
<!--            [classes]="['btn-first', 'float-right']"-->
<!--            (onEvent)="triggerNextStep()"-->
<!--            [dataCyAttribute]="'continue'"-->
<!--          ></btn>-->
<!--        </div>-->
<!--      </div>-->
<!--    </ng-container>-->
<!--    <ng-container class="back-button">-->
<!--      <btn-->
<!--        [label]="'back'"-->
<!--        [title]="'back' | translate"-->
<!--        [isBackButton]="true"-->
<!--        [classes]="['btn-third', 'float-right', 'me-2']"-->
<!--        [dataCyAttribute]="'order-back-button'"-->
<!--        [icon]="'far-arrow-left'"-->
<!--        (onEvent)="triggerBackBtn()"-->
<!--      ></btn>-->
<!--    </ng-container>-->
<!--  </page-header>-->
<!--  <section class="content order-content">-->
<!--    <router-outlet></router-outlet>-->
<!--  </section>-->
<!--</div>-->
